import React from 'react';
import moment from 'moment';
import { Card, Badge } from 'react-bootstrap';
import { CardStyle } from './styles/Card';

type Props = any;
const TicketCard: React.FC<Props> = ({ ticket }) => {
  const { id, status, title, message, createdAt } = ticket;
  return (
    <CardStyle to={`/tickets/${id}`}>
      <Card>
        <Card.Header>
          {title}
          <Badge
            pill
            variant={
              status === 'OPEN'
                ? 'secondary'
                : status === 'IN-REVIEW'
                ? 'info'
                : 'success'
            }
          >
            {status}
          </Badge>
        </Card.Header>

        <Card.Body>{message}</Card.Body>
        <Card.Footer className="text-muted">
          Created: {moment.utc(createdAt).format('MMMM Do, YYYY')}
        </Card.Footer>
      </Card>
    </CardStyle>
  );
};

export default TicketCard;
